import { useAppSelector } from 'features/app/hooks';
import { callTakenTimeSelector } from 'features/call/call-base/store/selectors';

export const useConvertDataFromISOString = () => {
  const callTakenTime = useAppSelector(callTakenTimeSelector);
  const date = new Date(callTakenTime);
  const formattedDate = date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });

  return `${formattedDate} ${formattedTime}`;
};
